import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Minecraft = () => {
    return (
        <div className="App" style={{ margin: "-8px" }}>
            <HelmetProvider>
                <Helmet>
                    <title>Minecraft Server</title>
                    <meta
                        name="Minecraft Server"
                        content="How to Join"
                        description="How to Join"
                        author="Jack Frederick"
                    />
                </Helmet>
            </HelmetProvider>
            <Warning></Warning>
            <Navbar></Navbar>
            <header className="Home">
                <p className="Homethick">
                    Minecraft Server
                </p>
                <br></br>
                <p className="Homethick-sm">
                    Please contact me to be added to the whitelist.
                </p>
                <p className="Homesmall">
                    IP: minecraft.csfrederick.com
                </p>
                <br></br>
                <br></br>
                <a className="Homesmall ats" style={{ color: "black" }} href="/">
                    Go Back Home
                </a>

            </header>
            <Footer></Footer>
        </div>
    );
};

export default Minecraft;
